<script lang="ts">
    import { getProductPrice } from "../../../../api/hooks/lib/ssr"
    import { companyName } from "../../config"
    import { langField } from "../../i18n"
    import { location } from "../../store"
    export let product: TProduct
</script>

<svelte:head>
    <link rel="canonical" href="{$location.url}" />

    <meta property="product:brand" content="{companyName}" />

    <meta property="product:name" content="{langField(product.name)}" />

    <meta property="product:price:amount" content="{String(getProductPrice(product, null, null, false))}" />

    <meta property="product:price:currency" content="EUR" />
</svelte:head>
